export const PENDING = 'Pendiente';
export const REJECTED = 'Rechazado';
export const REJECT = 'Rechazo';
export const FINISHED = 'Terminado';
export const ACCEPTED = 'Aceptado';
export const CANCELED = 'Cancelado';
export const INCOMPLETE = 'Incompleto';
export const CONDITIONATE = 'Condicionado';
export const INPROCESS = 'En Proceso';
